module.exports = __webpack_public_path__ + "img/SDG-14-EN-INVERTED.34dc19d8.png";